var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId } from 'react';
import classNames from 'classnames';
import { Tooltip } from './Tooltip';
export var BaseRadioButton = React.forwardRef(function (_a, ref) {
    var children = _a.children, checked = _a.checked, className = _a.className, labelProps = _a.labelProps, selectedValue = _a.selectedValue, tooltip = _a.tooltip, _b = _a.tooltipProps, tooltipProps = _b === void 0 ? {} : _b, value = _a.value, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, inputProps = __rest(_a, ["children", "checked", "className", "labelProps", "selectedValue", "tooltip", "tooltipProps", "value", "onChange"]);
    var id = useId();
    var labelClasses = classNames({ 'ffe-radio-button--with-tooltip': tooltip }, className);
    var isSelected = selectedValue === undefined ? checked : selectedValue === value;
    return (React.createElement(React.Fragment, null,
        React.createElement("input", __assign({ className: "ffe-radio-input", id: id, ref: ref, type: "radio", checked: isSelected, value: "".concat(value), onChange: onChange }, inputProps)),
        React.createElement("label", __assign({ htmlFor: id }, labelProps, { className: labelClasses }),
            React.createElement("span", { className: "ffe-radio-input__content" }, children)),
        tooltip && React.createElement(Tooltip, __assign({}, tooltipProps), tooltip)));
});
